export function getPageViewEvent({ siteId, data }) {
  return {
    type: 'PAGE_VIEW',
    data,
    siteId,
  };
}

export function getTrackingEvent({ type, siteId, data }) {
  return {
    type,
    data,
    siteId,
  };
}
//
// export function getSignInEvent() {
//   return {
//     type: 'SIGN_IN',
//     data: {},
//   };
// }
//
// export function getSignOutEvent() {
//   return {
//     type: 'SIGN_OUT',
//     data: {},
//   };
// }
//
// export function getAccountCreatedEvent() {
//   return {
//     type: 'ACCOUNT_CREATED',
//     data: {},
//   };
// }
//
// export function getAddCartEvent(url) {
//   return {
//     type: 'ADD_CART',
//     data: {
//       url,
//     },
//   };
// }



// WEBPACK FOOTER //
// ./src/tracking/events/index.js